<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        "
      >
        <h5 class="mb-0">
          {{ Object.entries(data).length === 0 ? $t("Add New") : $t("Update") }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- Form -->
      <validation-observer ref="formData">
        <b-form class="p-2">
          <b-row>
            <b-col cols="12">
              <!-- firstName -->
              <b-form-group
                :label="$t('Limit Member')"
                label-for="register-limitMember"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Limit Member"
                  vid="limitMember"
                  rules=""
                >
                  <b-form-input
                    id="register-limitMember"
                    v-model="limitMember"
                    name="register-limitMember"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Limit Member')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              class="mb-1"
            >
              <span>{{ $t('openTime') }}</span>
            </b-col>
            <b-col cols="6">
              <!-- firstName -->
              <b-form-group
                :label="$t('Hour')"
                label-for="register-openTimeHour"
              >
                <validation-provider
                  #default="{ errors }"
                  name="openTimeHour"
                  vid="openTimeHour"
                  rules=""
                >
                  <b-form-input
                    id="register-openTimeHour"
                    v-model="openTime.hour"
                    name="register-openTimeHour"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Hour')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <!-- firstName -->
              <b-form-group
                :label="$t('Minute')"
                label-for="register-openTimeMinute"
              >
                <validation-provider
                  #default="{ errors }"
                  name="openTimeMinute"
                  vid="openTimeMinute"
                  rules=""
                >
                  <b-form-input
                    id="register-openTimeMinute"
                    v-model="openTime.minute"
                    name="register-openTimeMinute"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Minute')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              class="mb-1"
            >
              <span>{{ $t('closeTime') }}</span>
            </b-col>
            <b-col cols="6">
              <!-- firstName -->
              <b-form-group
                :label="$t('Hour')"
                label-for="register-closeTimeHour"
              >
                <validation-provider
                  #default="{ errors }"
                  name="closeTimeHour"
                  vid="closeTimeHour"
                  rules=""
                >
                  <b-form-input
                    id="register-closeTimeHour"
                    v-model="closeTime.hour"
                    name="register-closeTimeHour"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Hour')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <!-- firstName -->
              <b-form-group
                :label="$t('Minute')"
                label-for="register-closeTimeMinute"
              >
                <validation-provider
                  #default="{ errors }"
                  name="closeTimeMinute"
                  vid="closeTimeMinute"
                  rules=""
                >
                  <b-form-input
                    id="register-closeTimeMinute"
                    v-model="closeTime.minute"
                    name="register-closeTimeMinute"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Minute')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Action button -->
          <div class="d-flex mt-2">
            <b-button
              variant="primary"
              class="mr-2"
              @click="validationForm()"
            >
              {{ $t("Submit") }}
            </b-button>
            <b-button
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t("Cancel") }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BSidebar,
  BButton,
  BInputGroupAppend,
  BInputGroup,
  BFormInput,
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BLink,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'

import vSelect from 'vue-select'
import store from '@/store'

// eslint-disable-next-line import/extensions
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    flatPickr,
    BSidebar,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    // eslint-disable-next-line vue/no-unused-components
    BInputGroupAppend,
    // eslint-disable-next-line vue/no-unused-components
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BLink,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isSidebarActive',
    event: 'update:is-sidebar-active',
  },
  props: {
    storeModuleName: {
      type: String,
      required: true,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    day: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      dataId: null,
      openTime: { hour: 8, minute: 0 },
      closeTime: { hour: 16, minute: 0 },
      limitMember: 0,
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    language() {
      return store.state.appConfig.systemConfig ? store.state.appConfig.systemConfig.language : []
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        if (Object.entries(this.data).length === 0) {
          this.$refs.formData.reset()
          this.initValues()
        } else {
          const {
            _id,
            openTime,
            closeTime,
            limitMember,
          } = this.data
          this.dataId = _id
          this.openTime = openTime
          this.closeTime = closeTime
          this.limitMember = limitMember
        }
      }
    },
  },
  methods: {
    initValues() {
      this.dataId = null
      this.openTime = { hour: 8, minute: 0 }
      this.closeTime = { hour: 16, minute: 0 }
      this.limitMember = 0
      // this.$refs.refInputEl.reset()
    },
    validationForm() {
      this.$refs.formData.validate().then(success => {
        if (success) {
          const obj = {
            id: this.dataId,
            openTime: this.openTime,
            closeTime: this.closeTime,
            day: this.day,
            queueServiceId: this.$route.params.id,
            limitMember: this.limitMember,
          }
          this.$emit('update:show', true)
          if (this.dataId !== null) {
            store
              .dispatch(`${this.storeModuleName}/updatePeriod`, obj)
              .then(result => {
                this.$emit('update:is-sidebar-active', false)
                this.$emit('update:show', false)
                console.log('fetch Success : ', result)
                // this.showToast('success', 'bottom-right')
              })
              .catch(error => {
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
                this.$emit('update:show', false)
                // this.showToast('danger', 'bottom-right')
              })
          } else {
            delete obj.id
            store
              .dispatch(`${this.storeModuleName}/addPeriod`, obj)
              .then(result => {
                this.$emit('update:is-sidebar-active', false)
                this.$emit('update:show', false)
                console.log('fetch Success : ', result)
                // this.showToast('success', 'bottom-right')
              })
              .catch(error => {
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
                this.$emit('update:show', false)
                // this.showToast('danger', 'bottom-right')
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.btn-remove {
  position: absolute;
  top: 20%;
  left: 30%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: red;
  color: white;
  font-size: 12px;
  padding: 12px 16px;
  border: none;
  cursor: pointer;
  border-radius: 15px;
  text-align: center;
}
.imgs-show {
  // width: 100%;
  height: 100px;
}
</style>
